import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import LlMenu from '@/components/LlMenu.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';

// Presentational only — FixedFeesTable.vue owns the selection, the store calls,
// the confirmation dialogs and the partial-success summary, the same split
// BulkActionBar.vue uses on the Matters page.

export default /*@__PURE__*/_defineComponent({
  __name: 'FixedFeeBulkActionsMenu',
  props: {
  selectedCount: { type: Number, required: true },
  loading: { type: Boolean, default: false },
  // Absent rather than disabled when unavailable — no flag, no firm setting or
  // no permission (leanlaw-ux-principles.md #5, BR-018).
  showLockActions: { type: Boolean, default: false },
},
  emits: [
  'mark-complete',
  'mark-incomplete',
  'lock-time',
  'unlock-time',
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// LlMenu renders `icon` as the <i>'s class list and calls `action` on click, so
// colour rides on the icon and each event name is type-checked by defineEmits.
// The greens and oranges are the exact colours the completion pair carried as
// standing buttons; green locked / red unlocked is the Time Lock status column's
// language (frd.md §3.2).
const completionItems = [
  {
    id: 'mark-complete',
    title: 'Mark Complete',
    icon: 'mdi mdi-check-circle-outline text-green-darken-1',
    dataCy: 'mark-complete-item',
    action: () => emit('mark-complete'),
  },
  {
    id: 'mark-incomplete',
    title: 'Mark Incomplete',
    icon: 'mdi mdi-close-circle-outline text-orange-darken-1',
    dataCy: 'mark-incomplete-item',
    action: () => emit('mark-incomplete'),
  },
];

// The divider separates visually without nesting a group.
//
// Matches the Time Lock Status column: grey for locked, green for unlocked.
// Neither is an alert colour, since neither action is an error or destructive.
// The completion pair above keeps its own colours, which predate this feature.
const lockItems = [
  { id: 'lock-divider', divider: true },
  {
    id: 'lock-time',
    title: 'Lock Time',
    icon: 'mdi mdi-lock text-grey-darken-1',
    dataCy: 'lock-time-item',
    action: () => emit('lock-time'),
  },
  {
    id: 'unlock-time',
    title: 'Unlock Time',
    icon: 'mdi mdi-lock-open text-green-darken-1',
    dataCy: 'unlock-time-item',
    action: () => emit('unlock-time'),
  },
];

const menuItems = computed(() => [
  ...completionItems,
  ...(props.showLockActions ? lockItems : []),
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LlMenu, {
    items: menuItems.value,
    location: "bottom end"
  }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createVNode(LlSecondaryButton, _mergeProps(menuProps, {
        variant: "outlined",
        "append-icon": "mdi-menu-down",
        disabled: __props.selectedCount === 0 || __props.loading,
        "data-cy": "fixed-fee-more-actions-button"
      }), {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" More actions ", -1)
        ]))]),
        _: 1
      }, 16, ["disabled"])
    ]),
    _: 1
  }, 8, ["items"]))
}
}

})